import { render, staticRenderFns } from "./AcordionA.vue?vue&type=template&id=2fa94532&lang=pug&"
import script from "./AcordionA.vue?vue&type=script&lang=js&"
export * from "./AcordionA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports